import { ThemeColors } from "../../../../../theme/themeValues";

interface CustomLegendProps {
	payload?: Array<{
		id?: string;
		value: string;
		type: string;
		color: string;
	}>;
}

const CustomLegend = ({ payload = [] }: CustomLegendProps) => {
	return (
		<div
			style={{
				display: "flex",
				justifyContent: "center",
				flexWrap: "wrap",
				gap: 12,
				paddingBottom: 32,
				fontSize: 12,
			}}
		>
			{payload.map((entry, index) => (
				<div
					key={entry.id ?? entry.value ?? index}
					style={{
						display: "flex",
						alignItems: "center",
						gap: 4,
						whiteSpace: "nowrap",
					}}
				>
					<svg width="12" height="12" viewBox="0 0 12 12">
						<rect rx="4" width="12" height="12" fill={entry.color} />
					</svg>

					<span style={{ color: "ThemeColors.LightBackgroundContrastText", lineHeight: 1 }}>
						{entry.value}
					</span>
				</div>
			))}
		</div>
	);
};

export default CustomLegend;
